module.exports = __webpack_public_path__ + "static/media/logo1.0db8ed98.svg";